export default __webpack_public_path__ + "1b8584ea013049faa31a66750b26fbe1.coffee";